import { Navigate, Route, Routes } from "react-router-dom";

import { Site } from "../../model/site";
import { SubscriptionCancelPage } from "./pages/Cancel";
import { CheckoutPage } from "./pages/Checkout";
import { SubscriptionDetailPage } from "./pages/Detail";
import { FeaturesPage } from "./pages/Features";
import { SubscriptionListPage } from "./pages/List";
import { BillingPage } from "./pages/Manage/BillingPage";
import { ChangePlanPage } from "./pages/Manage/ChangePlanPage";
import { PaymentMethodPage } from "./pages/Manage/PaymentMethodPage";
import { ToCardPage } from "./pages/Manage/ToCardPage";
import { PaymentPendingPage } from "./pages/PaymentPending";
import { RenewPage } from "./pages/Renew";
import { SiteSelection } from "./pages/SiteSelection";
import { SuccessPage } from "./pages/Success";

type Props = {
  site?: Site;
  setSite: (site: Site) => void;
};

export const SubscriptionPage = ({ site, setSite }: Props) => {
  return (
    <Routes>
      <Route path="features" element={<FeaturesPage site={site} setSite={setSite} />} />
      <Route path="selection" element={<SiteSelection />} />
      <Route path="checkout" element={<CheckoutPage site={site} setSite={setSite} />} />
      <Route path="checkout/pending" element={<PaymentPendingPage site={site} setSite={setSite} />} />
      <Route path="success" element={<SuccessPage setSite={setSite} />} />
      <Route path="detail" element={<SubscriptionDetailPage setSite={setSite} />} />
      <Route path="payment-method" element={<PaymentMethodPage />} />
      <Route path="change-plan" element={<ChangePlanPage />} />
      <Route path="to-card" element={<ToCardPage />} />
      <Route path="billing" element={<BillingPage />} />
      <Route path="renew" element={<RenewPage />} />
      <Route path="cancel" element={<SubscriptionCancelPage />} />
      <Route path="list" element={<SubscriptionListPage />} />
      <Route path="*" element={<Navigate to="/subscription/features" />} />
    </Routes>
  );
};
